import styled from 'styled-components'

import theme from 'theme_'

export const StyledLoginInner = styled.div`
  margin-bottom: ${theme.spacing.lg};
`

export const StyledLoginWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`
